import { FormEvent, useState } from "react";
import { Button, Form, Input } from "reactstrap";
import { TypeMessageHere } from "../../../../../constants";
import { useAppDispatch, useAppSelector } from "../../../../../reduxToolkit/hooks";
import { replyByUserAsync, sendMessageAsync } from "../../../../../reduxToolkit/reducers/chatSlice";
import EmojiPicker from "emoji-picker-react";
import ChatDropdown from "./ChatDropdown";

// This component handles user input for sending messages in a chat interface. It includes an input field, an emoji picker, and a send button.
const MessageInput = () => {
  const [messageInput, setMessageInput] = useState("");
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const { chats, selectedUser, currentUser } = useAppSelector((state) => state.chat);
  const dispatch = useAppDispatch();
  const addEmoji = (emoji: string) => {
    const text = `${messageInput}${emoji}`;
    setShowEmojiPicker(false);
    setMessageInput(text);
  };
  const handleMessageChange = (message: string) => {
    setMessageInput(message);
  };

  const handleMessagePress = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    // Scroll the chat container down after sending a message
    var container = document.getElementsByClassName("msger-chat")[0];
    setTimeout(() => {
      container?.scrollBy({ top: 200, behavior: "smooth" });
    }, 310);
    let currentUserId = currentUser?.id;
    let selectedUserId = selectedUser?.id;
    let selectedUserName = selectedUser?.name;
    if (messageInput.length > 0) {
      dispatch(sendMessageAsync({ currentUserId, selectedUserId, messageInput, chats }));
      setMessageInput("");
      // Simulate an automated reply after 2 seconds
      setTimeout(() => {
        const replyMessage = "Hey This is " + selectedUserName + ", Sorry I'm busy right now, I will text you later";
        dispatch(replyByUserAsync({ currentUserId, selectedUserId, replyMessage, chats }));
      }, 2000);
    }
  };
  return (
    <Form className="msger-inputarea" onSubmit={handleMessagePress}>
      <ChatDropdown />
      <Input className="msger-input" type="text" placeholder={TypeMessageHere} value={messageInput} onChange={(e) => handleMessageChange(e.target.value)} />
      <div>{showEmojiPicker ? <EmojiPicker onEmojiClick={({ emoji }) => addEmoji(emoji)} /> : null}</div>
      <div className="smiley-box">
        <div className="second-btn" onClick={() => setShowEmojiPicker(!showEmojiPicker)} />
      </div>
      <Button color="primary" className="msger-send-btn">
        <i className="fa fa-location-arrow" />
      </Button>
    </Form>
  );
};

export default MessageInput;
